// @mui
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
// routes
import { paths } from 'src/routes/paths';
import { useParams } from 'src/routes/hook';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
//
import { usePortal } from 'src/hooks/use-portal';
import { useMemo } from 'react';
import ProductList from 'src/sections/product/product-list';
import { ProductItemSkeleton } from 'src/sections/product/product-skeleton';
import PostDetailsHero from '../post-details-hero';

// ----------------------------------------------------------------------

export default function CategoryDetailsHomeView({ isRTL }: any) {
  const params = useParams();

  const { id } = params;
  const { categories, products, loading } = usePortal({ categoryId: id });
  const category = useMemo(() => categories.find((cat: any) => cat._id === id), [categories, id]);
  const renderSkeleton = (
    <>
      {[...Array(16)].map((_, index) => (
        <ProductItemSkeleton key={index} />
      ))}
    </>
  );
  const renderPost = category && (
    <>
      <PostDetailsHero
        title={isRTL ? category.nameAr : category.name}
        author={category.sectionName}
        coverUrl={category.headimage}
        createdAt={category.createdAt}
      />

      <Container
        maxWidth="xl"
        sx={{
          py: 3,
          mb: 5,
          borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
        }}
      >
        <CustomBreadcrumbs
          links={[
            {
              name: isRTL ? 'الرئيسية' : 'Home',
              href: '/',
            },
            {
              name: isRTL ? 'الفئات' : 'Categories',
              href: paths.category.root,
            },
            {
              name: isRTL ? category.nameAr : category.name,
            },
          ]}
          sx={{ mx: 'auto' }}
        />
      </Container>

      <Container sx={{ mb: 5 }}>
        <Stack sx={{ mx: 'auto' }}>
          <Typography variant="subtitle1" sx={{ mb: 5 }}>
            {category?.desc}
          </Typography>
        </Stack>
        {/* <Grid container spacing={3}>
          {items.map((item: any) => (
            <Grid item xs={12} sm={6} md={4} key={item._id}>
              <ItemCard item={item} />
            </Grid>
          ))}
        </Grid> */}
        <ProductList products={products} loading={loading} />
      </Container>
    </>
  );

  return <>{loading ? renderSkeleton : renderPost}</>;
}
